import { ExogenousLine } from './exogenous-lines';
// Bug Fix 2659: Added a default incremental value to local temporary SID
let currentSID = -1;

export class ExogenousResponse extends ExogenousLine {
  Exogenous_Sid = currentSID--;
  User_ID: number = null;
  Equations: any[] = [];
}
